import type { TDefaults } from '@client/hooks/useTable';
import type { ITableParams } from '@client/types/antd.type';

export type TPaginationProps<T> = {
  total: number;
  tablePageSize?: number;
  pagination?: ITableParams['pagination'];
  entities?: T[];
  defaults?: TDefaults;
};

export const DEFAULT_CURRENT_PAGE = 1;
export const DEFAULT_SIZE_CHANGER = 50;
export const DEFAULT_PAGE_SIZE = 10;

export const handlePagination = <T>(
  props: TPaginationProps<T>,
): TPaginationProps<T>['pagination'] => {
  const {
    total,
    tablePageSize = DEFAULT_PAGE_SIZE,
    pagination = {},
    defaults,
  } = props;

  const dataSource = (props.entities || []) as T[];

  const { defaultCurrent = defaults?.defaultCurrent ?? DEFAULT_CURRENT_PAGE } =
    pagination;

  return {
    total,
    hideOnSinglePage: true,
    showSizeChanger: dataSource.length > DEFAULT_SIZE_CHANGER,
    showQuickJumper: dataSource.length > tablePageSize,
    placement: [dataSource.length ? 'bottomEnd' : 'none'],
    pageSize: tablePageSize,
    defaultCurrent,
    ...pagination,
  };
};
